import _map from "lodash/map"
import _split from "lodash/split"
import { capitalizeString } from "services/utils/capitalize"
import * as moment from "moment"
import "moment/locale/pt-br"

export const formatOptionDate = (monthsDetailsData) =>
  _map(monthsDetailsData, (date) => {
    const infoDate = _split(date.paymentDate, "/")
    const month = capitalizeString(moment(infoDate[0], "MM").format("MMMM"))
    const year = infoDate[1]

    return {
      value: date.invoiceKey,
      label: `${month} / ${year}`
    }
  })

export const formatToPayload = (paymentDate) =>
  _map(paymentDate, (date) => {
    return `${date.value.substr(4, 2)}/${date.value.substr(0, 4)}`
  })



// WEBPACK FOOTER //
// ./src/scenes/DetailingPosPreControle/utils/formatsDate.js